import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Pobednik',
    CORRECT_SCORE: 'Tačan rezultat na utakmici',
    TOTAL_GOALS: 'Ukupno golova',
    DOUBLE_CHANCE: 'Dupla šansa',
    UNDER_OVER: 'Više/Manje',
    UNDER_OVER_25: 'Više/Manje od 2.5',
    UNDER_OVER_25_INITIALS: 'V/M 2.5',
    UNDER_OVER_35_INITIALS: 'V/M 3.5',
    UNDER_OVER_15: 'Više/Manje od 1.5',
    ASIAN_HANDICAP: 'Azijski hendikep',
    HANDICAP: 'Konačan ishod sa hendikepom',
    HANDICAP_FIRST: 'Konačan ishod sa hendikepom - Domaćin 1+',
    HANDICAP_SECOND: 'Konačan ishod sa hendikepom - Gost 1+',
    UNDER_OVER_05: 'Manje/Više od 0.5',
    UNDER_OVER_35: 'Više/Manje od 3.5',
    BOTH_TEAMS_SCORE: 'Oba tima daju gol',
    BOTH_TEAMS_SCORE_INITIALS: 'GG/NG',
    HOME_TEAM_GOALS: '{0} daje gol',
    AWAY_TEAM_GOALS: '{1} daje gol',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Klađenje da oba tima daju gol',
    WINNING_MARGIN: 'Margina pobede na utakmici',
    CORRECT_SCORE_GROUP: 'Tačan rezultat tima',
    HOME_TEAM_TO_SCORE: '{0} postiže gol',
    AWAY_TEAM_TO_SCORE: '{0} postiže gol',
    FIRST_TEAM_TO_SCORE: 'Tim koji prvi postiže gol',
    LAST_TEAM_TO_SCORE: 'Tim koji je postigao poslednji gol',
    HALF_TIME_FULL_TIME: 'Poluvreme-Kraj',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Half Time Result',
    FIRST_LAST_TO_SCORE: 'First / Last to Score',
    LAST: 'Poslednji',
    FIRST: 'Prvi',
    IN: 'u',
    LAST_THREE_GAMES: 'Poslednje 3 igre',
    PREVIOUS: 'Prethodnih',
    EIGHT_RESULTS: '8 utakmica',
    EIGHT_GAMES: '8 igara',
    OVER_25: 'Preko 2.5',
    UNDER_25: 'Ispod 2.5',
    OVER_35: 'Preko 3.5',
    UNDER_35: 'Ispod 3.5',
    COVERED: 'Ostvareno',
    DID_NOT_COVER: 'Nije ostvareno',
    SPREAD: 'Hendikep',
    TOTAL_POINTS_UNDER_OVER: 'Ukupno poena - Više/Manje',
    TOTAL_POINTS_OVER_UNDER: 'Ukupno poena - Više/Manje',
    MONEYLINE: 'Pobednik igre',
    TOTAL_POINTS_GROUP: 'Ukupan broj poena na meču',
    MONEY_LINE_TOTAL_POINTS: 'Pobednik + Ukupno poena',
    SPREAD_TOTAL_POINTS: 'Hendikep + Ukupno poena',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Nerešeno',
    'HD': '{0}/Nerešeno',
    'DA': 'Nerešeno/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Manje od 2.5',
    'Over 2.5': 'Više od 2.5',
    'Under 1.5': 'Manje od 1.5',
    'Over 1.5': 'Više od 1.5',
    'Under': 'Manje {0}',
    'Over': 'Više {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Manje od 0.5',
    'Over 0.5': 'Više od 0.5',
    'Under 3.5': 'Manje od 3.5',
    'Over 3.5': 'Više od 3.5',
    'Both Score Yes': 'Da',
    'Both Score No': 'Ne',
    'Home Not to Score': '{0} Neće dati gol',
    'Home Exactly 1': '{0} daje tačno 1 gol',
    'Home Exactly 2': '{0} daje tačno 2 gola',
    'Home Exactly 3': '{0} daje tačno 3 gola',
    'Home Exactly 4': '{0} daje tačno 4 gola',
    'Away Not to Score': '{1} Neće dati gol',
    'Away Exactly 1': '{1} daje tačno 1 gol',
    'Away Exactly 2': '{1} daje tačno 2 gola',
    'Away Exactly 3': '{1} daje tačno 3 gola',
    'Away Exactly 4': '{1} daje tačno 4 gola',
    'Home to Win and both teams to score': '{0} pobeđuje + oba tima daju gol',
    'Home to Win to nil': '{0} pobeđuje bez gola protivnika',
    'Score draw': 'Nerešeno',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} pobeđuje + oba tima daju gol',
    'Away to Win to nil': '{1} pobeđuje bez gola protivnika',
    'Home Win By Exactly 1 Goal': '{0} pobeđuje sa tačno 1 golom',
    'Home Win By Exactly 2 Goals': '{0} pobeđuje sa tačno 2 gola',
    'Home Win By 3 or more goals': '{0} pobeđuje sa 3 ili više golova',
    'Away Win By Exactly 1 Goal': '{1} pobeđuje sa tačno 1 golom',
    'Away Win By Exactly 2 Goals': '{1} pobeđuje sa tačno 2 gola',
    'Away Win By 3 or more goals': '{1} pobeđuje sa 3 ili više golova',
    'Draw With No Goals': 'Nerešen ishod bez golova',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Bilo koji drugi',
    'Home Not To Score': '{0} neće dati gol',
    'Home To Score': '{0} će dati gol',
    'Away Not To Score': '{1} neće dati gol',
    'Away To Score': '{1} će dati gol',
    'Home': '{0}',
    'No Goal': 'Neće biti golova',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Nerešeno',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Nerešeno/{0}',
    'Draw/Draw': 'Nerešeno/Nerešeno',
    'Draw/Away': 'Nerešeno/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Nerešeno',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Drugo',
    'Draw': 'Nerešeno',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Manje od 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Više od 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Manje od 26',
    '25 And Under Short': 'Manje od 26',
    '51 And Over': 'Više od 50',
    '51 And Over Short': 'Više od 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Američki',
    'Matchday': 'Dan meča',
    'Basketball': 'Košarka',
    'Dogs': 'Trke pasa',
    'Motor Racing': 'TRKE AUTOMOBILA',
    'Results': 'Rezultati',
    'Horses': 'Trke konja',
    'Soccer3 World Cup': 'World Cup',
    'Soccer': 'Fudbal',
    'US Football': 'Američki fudbal',
    'Marble Racing': 'Trke klikera',
    "Matchday_English": "Meč dana",
    "Matchday_Turkish": "Matchday",
    "Matchday_Greek": "Matchday",

    //Game SubTabs
    'Soccer_Euro': 'Euro liga',
    'Soccer_Soccer3_Super_League': 'Super liga',
    'Soccer_Soccer3_Greek_League': 'Greek liga',
    'Soccer_Super_League': 'Super liga',
    'Soccer_World_Cup': 'Svetski kup',
    'Soccer_Soccer3_World_Cup': 'Svetski kup',
    'Horses_Sprints': 'Sprintovi',
    'Horses_Flats': 'Galopi',
    'Horses_Jumps': 'Skokovi',
    'Basketball_US1': 'US',
    'Basketball_US2': 'US2',
    'Basketball_Europe': 'Evroliga',
    'Dogs_Flats': 'Stadion',
    'Dogs_City': 'Grad',
    'Motor_Racing_Stock_Cars': 'Trke automobila',
    'Motor_Racing_Indy_Cars': 'Trke formula',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Gradovi',
    'Marble_Racing_Marbles': 'Klikeri',
    'Marble_Racing_Marbles2': 'Pesak',
    'Marble_Racing_Marbles_Euro': 'Soccer',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Meč dana",
    "Matchday_Turkish_Matchday_Turkish": "Matchday",
    "Matchday_Greek_Matchday_Greek": "Matchday",

    //Racing
    FORECAST: 'Prva dva',
    TRICAST: 'Prva tri',
    REVERSE_FORECAST: 'Kombinacija za prva dva',
    REVERSE_TRICAST: 'Kombinacija za prva tri',
    FIRST_ST: '1.',
    SECOND_ND: '2.',
    THIRD_RD: '3.',
    RD: ' ',
    ST: ' ',
    ND: ' ',
    ANY: 'Bilo koji',
    TO_WIN: 'Pobednik',
    RACE_CARD: 'NAPRAVI IZBOR',
    EACH_WAY: 'Pobednik-mesto',
    EW: 'P/M',
    FORECAST_TRICAST: 'Prva dva/Prva tri',
    EACH_WAY_ODDS_PLACE: 'P/M {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'P/M {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Broj',
    SORT_BY: 'Sortiraj po',
    BET_SLIP: 'Tiket',
    CLOSE_BET_SLIP: 'Zatvori',
    CLOSE_SLIP: 'Zatvori',
    PLACED_BETS: 'Postavi opkladu',
    SETTLED_BETS: 'Istorija',
    SLIP: 'Tiket',
    OPEN_BETS: 'Aktivan',
    CLEAR_SELECTIONS: 'Obriši opklade',
    ADD_TO_BET_SLIP: 'Dodaj na tiket',
    NO_BETS: 'Nema opklada',
    COMBINATION_TRICAST: 'Kombinacija za prva tri',
    COMBINATION_FORECAST: 'Kombinacija za prva dva',
    TOTAL_STAKE: 'Ukupna uplata',
    TOTAL_POTENTIAL_RETURNS: 'Ukupan potencijalni dobitak',
    N_A: 'N/A',
    PLACE_BETS: 'Postavite opkladu',
    REMOVE_ALL: 'Uklonite sve',
    POT_RETURNS: 'Pot. dobitak:',
    RETURNED: 'Isplaćeno:',
    REFUNDED: 'Refundirano',
    OK: 'OK',
    WIN_INITIAL: 'W',
    DRAW_INITIAL: 'N',
    LOSE_INITIAL: 'L',

    //Settings
    SETTINGS: 'Podešavanja',
    LANGUAGE: 'Language',
    LAYOUT: 'Prikaz',
    ODDS: 'Kvote',
    EN_GB: 'English UK',
    DECIMAL: 'Decimale',
    FRACTIONAL: 'Razlomci',
    AMERICAN: 'Američke',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Pažnja',
    WARNING_NOTIFICATION: 'Upozorenje',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Upozorenje',
    INFO_NOTIFICATION: 'OBAVEŠTENJE',
    SUCCESS_NOTIFICATION: 'Uspešno',

    SELECTION_REMOVAL: 'Ovaj izbor će biti uklonjen ',
    SECONDS: ' sekunde',
    SECOND: ' sekunde',
    REMOVE_CLOSED_EVENTS: 'Obrišite isktekle događaje',
    SET_VIDEO_ON_FUL_SCREEN: 'Da li želite video preko celog ekrana?',
    CANCEL: 'Otkaži',

    //Error codes
    INTERNAL_ERROR: 'Greška',
    OPEN_BETS_WARNING: 'Neke ili sve otvorene opklade nije moguće dodati na tiket jer pripadaju prošlim događajima.',
    '-32602': 'Jedna ili više opklada nisu izvršene na vreme.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Dostignut je maksimalan broj opklada na tiketu. Molimo uklonite neke opklade pre dodavanja novih.',

    '-20000': 'Nemoguće uspostaviti konekciju (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Nemoguće uspostaviti konekciju (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Previše zahteva (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Previše zahteva (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Nevažeći zahtev (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Nevažeći zahtev (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Nevažeći zahtev (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'Igra je otkazana. Molim Vas kontaktirajte kontakt centar.',
    '-999': 'Istekla sesija',
    '-998': 'Igrač je suspendovan',
    '-997': 'Komanda nije dozvoljena',
    '-996': 'Greška prilikom procesuiranja zahteva (Error Code:-996)', //Gaming System Error
    '-995': 'Greška prilikom procesuiranja zahteva (Error Code:-995)', //BMS Internal Error
    '-994': 'Izgubljena konekcija sa serverom, tiket nije uplaćen',
    '-980': 'Greška prilikom procesuiranja zahteva (Error Code:-980)', //Error processing game command.
    '-979': 'Greška prilikom procesuiranja zahteva (Error Code:-979)', //Error on Json message sent by Virgo.
    '-978': 'Nema dovoljno sredstava za izvršenje transakcije',
    '-977': 'Provera nije prošla',
    '-976': 'Operacija sa novčanikom igrača je privremeno blokirana',
    '-975': 'Istekao je limit za klađenje',
    '-974': 'Istekao je limit za granicu gubitka',
    '-973': 'Nije podešen limit',
    '-972': 'Greška kod uslova za odgovorno klađenje',
    '-971': 'Greška kod operacije sa novčanikom igrača',
    '-970': 'Odbijena transakcija sa novčanikom igrača',
    '-969': 'Odbijena komunikacija sa novčanikom igrača',
    '-968': 'Greška sa trnasakcijom novčanika igrača',
    '-967': 'Neuspešna identifikacija',
    '-966': 'Prekoračena je gornja granica dobitka',
    '-965': 'Prosleđeni nevalidni parametri',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Iznos uloga mora biti u okviru definisanih granica. Minimalni ulog je {0}. Maksimalni ulog je {1}',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Tiket premašuje maksimalnu isplatu od {0}',
    BET_NON_DIVISIBLE_MESSAGE: 'Jedna ili više opklada nisu deljive sa {0}. Ispravite ovo pre nego što stavite opklade.',
    SINGLE_BET_COMMIT_MESSAGE: 'You cannot place multiple single bets',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Opklade koje uplaćujete su veće od {0}.',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Da li je ovo u redu?',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'Uložen je maksimalni iznos od {0}. Molimo izaberite drugi događaj',

    //SIMPLIFIED UI
    TOTAL_BETS: 'TOTAL BET:',
    PLACE_YOUR_BETS: 'Postavi opkladu',
    RACE_START: 'Vreme početka',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Rezime opklade',
    NO_BETS_RESUME: 'Nema opklada',
    LIVE: 'Uživo',
    RACERS: 'Racers',
    SELECTION: 'Izbor',
    DATE_LOCATION: 'Događaj',
    STAKE: 'Ulog',
    BET_TYPE_STAKE: 'Vrsta opklade/Ulog',
    POTENTIAL_RETURNS: 'Pot.Dobitak',
    BET_HISTORY: 'Istorija opklada',
    BET_HISTORY_LABEL: 'Istorija opklada',
    FILTER_WINS: 'Filtriraj dobitne',
    NEXT_RACE: 'Sledeća trka',
    WIN: 'Pobednik',
    PLACE: 'U prva dva ',
    SHOW: 'U prva tri ',
    EXACTA: 'Forecast',
    TRIFECTA: 'Tricast',
    NO_WIN: 'NO WIN',
    WON: 'Dobitan',
    LOST: 'Gubitan',
    CURRENT_RACE: 'Trenutna trka',
    BOX: 'BOX',
    TO: 'da',
    PAYS: 'pays',
    TRIFECTA_BOX: 'combination tricast',
    EXACTA_BOX: 'combination forecast',
    FINISH_YOUR_BETS: 'Završi opkladu',
    SELECT_YOUR_BET_BELOW: 'Izaberi opkladu ispod',
    BET: 'Opklada',
    REMOVED: 'Uklonjena',
    RESULT: 'Rezultat',
    GOALS: 'Golovi',
    NO_MORE_BETS: 'Opklade su zatvorene',
    EVENT_LIVE_MSG_LINE_1: 'Izabrani đogađaj se sada prikazuje.',
    EVENT_LIVE_MSG_LINE_2: 'Izaberite neki od budućih događaja.',
    EVENT_LIVE_MSG_LINE_3: ' ',
    NO_FUTURE_EVENTS: 'Ponuda se učitava',
    AUTHENTICATION_REQUIRED: 'Da biste nastavili, potrebno je da se ulogujete.',
    GAME_DISABLED: 'Igra je neomogućena',
    GAME_DISABLED_MESSAGE: 'Molim Vas, kontaktirajte korisnički servis.',
    VOIDED: 'Poništen',
    HELP: 'Pomoć',
    LAST_RESULTS: 'Poslednji rezultati',
    NO_LAST_RESULTS: 'Nema prethodnih rezultata',
    PREVIOUS_RESULTS: 'Prethodni rezultati',
    OFFENSE_PREVIOUS_RESULTS: 'Offence Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defence Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Idite na sledeći',
    SCHEDULED_EVENT: 'zakazani događaj',
    LOOK_FOR_THE: 'Idite na',
    NEXT_SCHEDULED: 'sledeći zakazani',
    EVENT: 'događaj',
    RETURNS: 'Dobitak',
    NEXT: 'Sledeći',
    FUTURE: 'Budući',
    PLAYING: 'Playing',

    //MESSAGE BAR
    ON: 'na',
    MB_RACE_ON: 'na',
    MB_RACE_WIN: 'pobednik',
    MB_RACE_PLACE: 'u prva dva',
    MB_RACE_SHOW: 'u prva tri',
    MB_RACE_TRIFECTA_BOX: 'kombinacija za prva tri',
    MB_RACE_EXACTA_BOX: 'kombinacija za prva dva',
    MB_RACE_EXACTA: 'prva dva',
    MB_RACE_TRIFECTA: 'prva tri',
    MB_FOOTBALL_ON: 'na',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Clear Last',
    CLEAR_ALL: 'Obriši sve',
    ACTIVE_BETS: 'Aktivne opklade',
    ONLY_SHOW_WINS: 'Prikaži samo dobitne',
    MORE: 'Više',
    BETS: 'Opklade',
    LOADING: 'Učitava se',
    BET_SELECTION_MESSAGE: 'Napravite svoj izbor(e) klikom na kvotu.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'poništi',
    CLEAR: 'obriši',
    HISTORY: 'istorija',

    MARKETS: 'Tipovi klađenja',
    MAIN: 'Glavni meni',
    VS: 'vs',
    AT: '@',
    SCORE: 'Rezultat',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Detalji',
    NO_GOALS: 'Bez golova',

    MAX_WINNINGS_REACHED: 'Maksimalni dobitak postignut',
    MAX_WINNINGS_REACHED_TEXT: 'Trenutna opklada će premašiti maksimalnu isplatu od {0}. Maksimalna dozvoljena vrednost uloga za ovu opkladu je {1}.',
    NO_CONNECTION_TITLE: 'Izgubljena konkecija',

    NO_CONNECTION_TITLE_TEXT: 'Veza je prekinuta sa serverom. Proverite da li imate stabilnu mrežnu vezu i osvežite stranicu. Ako se problem nastavi, obratite se podršci.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Veza je zatvorena, korisnik je dva puta povezan.',
    BET_CONFIRMED_TEXT: 'none',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Konekcija je izgubljena',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Molim Vas osvežite stranu i ulogujte se',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Vaš trenutni browser nije podržan. Koristite jedan od sledećih browser-a: Chrome, Firefox ili Safari.',
    'BROWSER_NOT_SUPPORTED': 'Browser nije podržan',
    'DOWNLOAD_CHROME': 'Preuzmite Chrome',
    'DOWNLOAD_FIREFOX': 'Preuzmite Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Preko 219.5',
    'Under 219.5': 'Ispod 219.5',
    'Over 214.5': 'Preko 214.5',
    'Under 214.5': 'Ispod 214.5',
    'Over 209.5': 'Preko 209.5',
    'Under 209.5': 'Ispod 209.5',
    'Over 144.5': 'Preko 144.5',
    'Under 144.5': 'Ispod 144.5',
    'Over 149.5': 'Preko 149.5',
    'Under 149.5': 'Ispod 149.5',
    'Over 154.5': 'Preko 154.5',
    'Under 154.5': 'Ispod 154.5',
    'Over 159.5': 'Preko 159.5',
    'Under 159.5': 'Ispod 159.5',
    'Over 164.5': 'Preko 164.5',
    'Under 164.5': 'Ispod 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'PRVA DVA/PRVA TRI',
    'FORECAST_MARBLE': 'Prva Dva',
    'TRICAST_MARBLE': 'Prva Tri',
    'REVERSE_FORECAST_MARBLE': 'Top 2 bilo koji redosled',
    'REVERSE_TRICAST_MARBLE': 'Top 3 bilo koji redosled',
    'TO_WIN_MARBLE': 'Pobednik',
    'PLACE_MARBLE': 'U prva dva',
    'SHOW_MARBLE': 'U prva tri',
    'MARBLE': 'Klikeri',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Jednako',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Pobeđuje u igri',
    'Any': 'Bilo koji',
    "BET_BOTH": "Opklada na oba tima",
    //Matchday
    "betSlip_Matchday_English": "Meč dana Engleska",
    "betSlip_Matchday_Turkish": "Matchday Turkish",
    "betSlip_Matchday_Greek": "Matchday Greek",
    "betSlip_Soccer": "Fudbal",
    "betSlip_Horses": "Trke konja",
    "betSlip_Basketball": "Košarka",
    "betSlip_Dogs": "Trke pasa",
    "betSlip_Motor Racing": "TRKE AUTOMOBILA",
    "betSlip_US Football": "Američki fudbal",
    "betSlip_Marble Racing": "Trke klikera",
    "POS": "poz",
    "TEAM": "tim",
    "P": "p",
    "W": "d",
    "D": "n",
    "L": "g",
    "F": "gol",
    "A": "gol_d",
    "PTS": "∑",
    "LEAGUE TABLE": "tabela liga",
    "TREND": "trend",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Više/Manje',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_SHORT: "M",
    OVER_SHORT: "V",
    "FULL TIME": "Konačni rezultat ",
    "FT": "Kraj",
    "System": "SISTEM",
    "x1": "(x1)",
    "Multiplier": "Ponovljena opklada",
    "Main markets": "GLAVNI MENI",
    "4RANDOM": "4 BRZIH IZBORA",
    "6RANDOM": "6 BRZIH IZBORA",
    "8RANDOM": "8 BRZIH IZBORA",
    "8FAVS": "8 FAVORITA",
    "QUICK_SELECT": "BRZI IZBOR",
    "UNDER": "MANJE",
    "OVER": "VIŠE",
    "UNDER_OVER_2_5": "Više/Manje 2.5",
    "UNDER_OVER_3_5": "Više/Manje 3.5",
    "MATCH_RESULT": "POBEDNIK",
    "YES": "Da",
    "NO": "Ne",
    "REALITY_CHECK_WARNING_YES": "Da",
    "REALITY_CHECK_WARNING_NO": "Ne",
    "ACCUMULATOR": "Akumulator",
    "+1G": "+1G",
    "Single": "Single",
    "Doubles": "Dubl",
    "Trebles": "Tripl",
    "Four Folds": "4 od",
    "Five Folds": "5 od",
    "Six Folds": "6 od",
    "Seven Folds": "7 od",
    "Eight Folds": "8 od",
    "MD": "MD{0}",
    "MATCH": "MEČ",
    "INVALID_ACCA": "Tamo gde se odabiri pojavljuju istaknuti, višestruki izbori su ograničeni",
    "INVALID_ODDS": "Vrednost kvote je previsoka. Promenite svoj izbor opklada",
    "INVALID_ACCA_MORETHAN_8": "Više opklada ne može da sadrži više od 8 izbora unutar jedne utakmice",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Pojačavanje dobitka',
    "Bonus_Info": " {0}% Bonus",
    "+": "+",
    "Bonus_Value": "Vrednost {0} Bonus",
    "ACCUMULATOR_INFO": 'Ako je opklada sa akumulatorom uspešna, bonus od {0}% - {1}% se dodaje vašim dobicima. Visina bonusa zavisi od broja odabira.',
    "BET_TYPE": 'Vrsta opklade',
    "BOOST": 'Pojačavanje',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} ili više opklada će omogućiti dobijanje bonusa',
    "BOOST_BONUS_UPGRADE": 'Dodajte još jednu opkalu da biste dobili dodatni bonus',
    "BOOST_BONUS_MAX": 'Dostigli ste maksimalnu vrednost bonusa',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Više {0}",
    "Short_Under": "Manje {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Potrebno je da se prijavite kako",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": "biste postavili opkladu",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Zatvori",
    "DEMOPLAY_NOTIFICATION_OK": "Prijavi se",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "DEMOPLAY_NOTIFICATION_OK": "Prijavi se",
    "QUICK_FILL": "Brzi unos uloga",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading":"ПОКЛОН ЗА ВАС",
    "Gift_for_You_Content":" Честитамо! Имате промотивне понуде које можете искористити.",
    "View_Offers":" ПОГЛЕДАЈТЕ ПОНУДЕ",
    "Do_Not_Show_MSG":" НЕ ПОКАЗУЈ ПОНОВО",
    "MY_OFFERS":" МОЈЕ ПОНУДЕ",
    "SELECT_OFFER":" ИЗАБЕРИТЕ СВОЈУ ПОНУДУ",
    "NO_OFFER":" НЕМА АКТИВНИХ ПОНУДА",
    "CHOOSE_BET":" ИЗАБЕРИТЕ ОПЛАДУ",
    "Opt_In":" ПРИЈАВИ СЕ",
    "Key_Terms_Heading":"КЉУЧНИ ПОЈМОВИ",
    "No_Thanks":" НЕ, ХВАЛА",
    "PROMO_BET":" ПРОМОТИВНА ОПЛАДА",
    "Time_To_Bet":" ВРЕМЕ ЗА КЛАЂЕЊЕ",
    "OPTED_IN_MSG":" ХВАЛА ШТО СТЕ СЕ ПРИЈАВИЛИ",
    "EXP":" Прим.",
    "SELECT":"изаберите",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "Овај демо сајт тренутно не нуди никакве промоције. Молимо вас да се пријавите/региструјете да бисте приступили тренутним промоцијама.!",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Kriket",
    "Cricket_International": "Međunarodni",
    "betSlip_Cricket": "Kriket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Nerešeno",
    //cricket markets
     "MATCH_WINNER":"Pobednik meča",
     "TOTAL_SIXES_IN_MATCH":"Ukupno 6‘s u meču",
     "TOTAL_SIXES_IN_MATCH_SHORT": "MANJE 1.5",
     "TOTAL_FOUR_IN_MATCH":"Ukupno 4‘s u meču",
     "TOTAL_BOUNDARIES_IN_MATCH":"Ukupno granica u meču",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Ukupno trčanja",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Trčanja sa prvom isporukom",
     "FIRST_TEAM_WICKET_LOST":"{0} Viket izgubljen",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Vrsta prvog načina poništavanja",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Trčanja sa prvom loptom preko/ispod",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Trčanja sa prvom loptom preko/ispod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Trčanja sa prvom loptom preko/ispod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Trčanja sa prvom loptom preko/ispod",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Trčanja sa prvom loptom preko/ispod",
     "Caught" : "Uhvaćena",
     "Bowled":"Kotrljana",
     "LBW":"LBW",
     "No Wicket":"Nema viketa",
     "OverZeroPointFive": "Više 0.5",
     "UnderZeroPointFive": "Manje 0.5",
     "OverOnePointFive": "Više 1.5",
     "UnderOnePointFive": "Manje 1.5",
     "OverTwoPointFive": "Više 2.5",
     "UnderTwoPointFive": "Manje 2.5",
     "OverThreePointFive": "Više 3.5",
     "UnderThreePointFive": "Manje 3.5",
     "Yes": "Da",
     "No":"Ne",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Više 14.5',
     UNDER_145: 'Manje 14.5',
     DRAW_Cricket: "NEREŠENO",
      //TENNIS
    TOTAL_POINTS:"UKUPNO POENA",
    HANDICAP_TENNIS: "HENDIKEP",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Međunarodno",
    betSlip_Tennis: "TENIS",
    "Win By 2 or 3": "Pobeda sa 3 poena ili više",
    "Win By 4 or 5": "Pobeda sa 4 ili 5 poena",
    "Win By 6 or 7": "Pobeda sa 6 ili 7 poena",
    "Tennis": "TENIS",
   //baseball
    WINNER : "POBEDNIK",
    TOTAL_HOME_RUNS_UNDER_OVER: "UKUPNO OPTRČAVANJA VIŠE/MANJE",
    TOTAL_HOME_RUNS:  "TAČAN UKUPAN BROJ OPTRČAVANJA",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"POBEDNIK I UKUPNOOPTRČAVANJA VIŠE/MANJE 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"POBEDNIK I UKUPNOOPTRČAVANJA VIŠE/MANJE 5,5",
    BATTER1_HOME_RUNS: "{0} OPTRČAVANJA",
    BATTER2_HOME_RUNS: "{1} OPTRČAVANJA",
    Baseball_HR_ShootOut_Legends: "Prepucavanje u optrčavanjima - Legende",
    Baseball_HR_ShootOut_Legends_SHORT: "Prepucavanje u optrčavanjima",
    "Baseball": "BEJZBOL",
    "betSlip_Baseball": "BEJZBOL",
    "Player 1 AND OVER_5_5":"{0} I Više od 5,5",
    "Player 2 AND OVER_5_5":"{0} I Više od 5,5",
    "Player 1 AND UNDER_5_5":"{0} I Manje od 5,5",
    "Player 2 AND UNDER_5_5":"{0} I Manje od 5,5",
    "Draw AND OVER_5_5":"Nerešeno i više od 5,5",
    "Draw AND UNDER_5_5":"Nerešeno i manje od 5,5",
    "HOME RUNS":"{0} OPTRČAVANJA",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'NOVO',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
};


// WEBPACK FOOTER //
// ./src/localization/sr_RS.js